/* MoodChart auto-generated by npm run generator */
import { Line, Serie } from "@nivo/line"
import { Checkin, clampNumber, moodOrder } from "@qlarity/common"
import ChartCard from "components/atoms/ChartCard"
import { observer } from "mobx-react"
import React from "react"
import { defaultTheme } from "style"
import { defaultNivo } from "style/nivoTheme"

interface MoodChartProps {
    checkins: (Checkin[] | undefined)[]
}

const MoodChart: React.FC<MoodChartProps> = ({ checkins }) => {
    const preparedData = React.useMemo((): Serie[] => {
        const moodTotals = moodOrder.map((mood) => ({ x: mood, y: 0 }))
        checkins?.forEach((clientCheckins) => {
            clientCheckins?.forEach((check) => {
                const idx = moodTotals.findIndex((mood) => mood.x === check.moodName)
                moodTotals[idx].y += 1
            })
        })
        return [{ id: "moods", data: moodTotals || [{}] }]
    }, [checkins])

    const numTicks = clampNumber(
        preparedData[0].data.reduce((max, curr) => (max >= (curr.y ?? 0) ? max : (curr.y as number)), 1),
        1,
        5
    )
    return (
        <ChartCard title="Mood Survey Results" subtitle="Mood Results">
            <Line
                theme={defaultNivo}
                width={600}
                height={300}
                data={checkins ? preparedData : [{ id: "moods", data: [{}] }]}
                margin={{ bottom: 24, top: 32, left: 40, right: 40 }}
                colors={defaultTheme.palette.info.main}
                pointSize={6}
                pointColor={defaultTheme.palette.background.default}
                pointBorderWidth={1}
                pointBorderColor={defaultTheme.palette.info.main}
                lineWidth={1}
                yScale={{ type: "linear", min: 0 }}
                axisLeft={{ tickValues: numTicks }}
                gridYValues={numTicks}
            />
        </ChartCard>
    )
}

export default observer(MoodChart)
